import {FC, ReactNode} from 'react'
import clsx from 'clsx'
import {tv} from "tailwind-variants";
import {backgroundColor} from "@/constants/constants";

const generateClasses = tv({
    slots: {
        root: [
            'container flex flex-wrap gap-mobile md:gap-2xl lg:gap-3xl px-mobile py-2xl md:p-2xl lg:p-3xl',
        ],
        alignCenter: '',
        color: '',
    },
    variants: {
        center: {
            true: {
                alignCenter: 'justify-center'
            },
        },
        backgroundColor: {
            'peach': {
                color: 'bg-brand-peach'
            },
            'light-peach': {
                color: 'bg-brand-light-peach'
            },
            'purple':{
                color: 'bg-brand-purple'
            },
            'light-purple':{
                color: 'bg-brand-light-purple'
            },
            'blue':{
                color: 'bg-brand-blue'
            },
            'light-blue':{
                color: 'bg-brand-light-blue'
            },
            'warm-grey':{
                color: 'bg-brand-warm-grey'
            },
            'light-warm-grey':{
                color: 'bg-brand-light-warm-grey'
            },
            'cool-grey':{
                color: 'bg-brand-cool-grey'
            },
            'light-cool-grey':{
                color: 'bg-brand-light-cool-grey'
            },
            'green': {
                color: 'bg-brand-green'
            },
            'light-green': {
                color: 'bg-brand-light-green'
            }
        }
    }
});

interface Props {
    children?: ReactNode,
    className?: string,
    backgroundColor?: backgroundColor,
    center?: boolean,
}

const Container: FC<Props> = ({
                                  children,
                                  className,
                                  backgroundColor,
                                  center = false,
                              }) => {

    const {root, alignCenter, color} = generateClasses({
        center,
        backgroundColor
    });

    return (
        <div
            className={clsx(
                root(),
                alignCenter(),
                color(),
                className
            )}
        >
            {children}
        </div>
    )
}

export default Container
